import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Example 1', 159, '11/02/2023', 24, 4.0),
  createData('Example 2', 237, '11/02/2023', 37, 4.3),
  createData('Example 3', 262, '11/02/2023', 24, 6.0),
  createData('Example 4', 305, '11/02/2023', 67, 4.3),
  createData('Example 5', 356, '11/02/2023', 49, 3.9),
];

export default function tableComparative() {
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead style={{ backgroundColor: 'gray', color: 'white' }}>
          <TableRow>
            <TableCell style={{ color: 'white' }}>Información</TableCell>
            <TableCell style={{ color: 'white' }}>Cantidad</TableCell>
            <TableCell style={{ color: 'white' }}>Fecha</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell >{row.calories}</TableCell>
              <TableCell >{row.fat}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
